import React, { useEffect } from 'react';
import { Spinner } from 'react-bootstrap';

const FacebookCallback = () => {
  useEffect(() => {
    // This component will be loaded in the popup window after Facebook OAuth redirect
    // Extract the access token and other parameters from the URL hash
    const hashParams = new URLSearchParams(
      window.location.hash.substring(1) // Remove the # character
    );
    
    // Get the parameters from the URL
    const accessToken = hashParams.get('access_token');
    const expiresIn = hashParams.get('expires_in');
    const state = hashParams.get('state');
    
    // If there's an error or the access token is missing, show an error message
    if (!accessToken) {
      // This will be shown briefly before the window is closed by the parent
      document.body.innerHTML = '<div style="text-align: center; padding: 20px;">Authentication failed. You can close this window.</div>';
      return;
    }
    
    // The window will be automatically closed by the parent window
    // which is monitoring this popup, so we just need to make sure
    // the URL contains the access token in the hash
    document.body.innerHTML = '<div style="text-align: center; padding: 20px;">Authentication successful! You can close this window.</div>';
  }, []);

  return (
    <div className="text-center p-5">
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
      <p className="mt-3">Processing Facebook login...</p>
    </div>
  );
};

export default FacebookCallback;
